import { default as _  } from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CaisServiceService } from '../../cais-service.service';
import { CaisExceptionServiceService } from '../../exceptions/cais-exception-service.service';
import { DataService } from 'app/Shared/Services/data.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LowerCasePipe, NgClass, CommonModule, SlicePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { TidGeneratorComponent } from '../../cais-tid/tid-generator/tid-generator.component';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { ToastModule } from 'primeng/toast';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TabsModule } from 'primeng/tabs';

@Component({
    selector: 'app-customerlist-details',
    templateUrl: './customerlist-details.component.html',
    imports: [ButtonModule, DialogModule, ConfirmDialogModule, MatTooltipModule,
        Select, FormsModule, NgClass, CommonModule, TableModule,
        LowerCasePipe, MultiSelectModule, DatePickerModule, ToggleSwitchModule,
        TabsModule, SlicePipe, MatListModule, MatDividerModule, ReactiveFormsModule,
        TidGeneratorComponent, ToastModule
    ],
    providers: [CaisExceptionServiceService, UserService,
        MessageService, UrlsService, ConfirmationService,
        ConstantService, DataService, SharedHttpClientService],
    styleUrls: ['./customerlist-details.component.scss']
})
export class CustomerlistDetailsComponent implements OnInit,OnChanges  {


  selectedTabIndex: number = 0;
  isAddLoadingResults: any = false;
  isEditLoadingResults: any = false;

  addScreenNegotiatedFields: Array<string>;
  editScreenNegotiatedFields: Array<string>;
  viewScreenNegotiatedFields: Array<string>;
  CommonNegotiatedFields: Array<string>;
  DisabledFields: Array<string>;
  editDisabledFields: Array<string>;
  editabledCaisCorrectionFields: Array<string>;
  inCustomerRecordID:any;

  NPTIDSwitches: any = [];
  LETIDSwitches: any = [];

  isClickOnTIDCorrection:boolean = false;


  @Input('finraExceptionRow') finraExceptionRow: any;
  @Input('NaturalPersons')
  NaturalPersons:  any[] = [];
  @Input('LegalEntities')
  LegalEntities: any[] = [];
  @Input('ExceptionInCustomerIDList') ExceptionInCustomerIDList: any=[];
  @Input('NaturalPersonScreenDataDetails') NaturalPersonScreenDataDetails: any = [];
  @Input('LegalEntityScreenDataDetails') LegalEntityScreenDataDetails: any = [];
  @Input('addressColumns') addressColumns: any = [];
  storeBirthYear: any;

  constructor(public caisExceptionServiceService: CaisExceptionServiceService,
    public caisServiceService: CaisServiceService,
    private messageService: MessageService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlService: UrlsService,
    private userService: UserService,
    public dataService: DataService
  ) {
    this.addScreenNegotiatedFields = this.caisServiceService.addScreenNegotiatedFields;
    this.editScreenNegotiatedFields = this.caisServiceService.editScreenNegotiatedFields;
    this.viewScreenNegotiatedFields = this.caisServiceService.viewScreenNegotiatedFields;
    this.CommonNegotiatedFields = this.caisServiceService.CommonNegotiatedFields;
    this.DisabledFields = this.caisServiceService.DisabledFields;
    this.editDisabledFields = this.caisServiceService.editDisabledFields;
    this.editabledCaisCorrectionFields = this.caisServiceService.editabledCaisCorrectionFields;
  }
  ngOnInit() {
    this.selectedTabIndex = 0;
    this.isClickOnTIDCorrection = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isClickOnTIDCorrection = false;
    this.findSelectedTabIndex();
    this.caisServiceService.maskYear()

  }
  findSelectedTabIndex() {
    let inCustomerRecordID: any = this.finraExceptionRow["inCustomerRecordID"];
    if (this.caisServiceService.NaturalPersonDataDetails.length > 0) {
      let indexForNaturalPerson = this.NaturalPersons.findIndex(function (item:any, i:any) {
        return item.inCustomerRecordID == inCustomerRecordID
      });
      if (indexForNaturalPerson > 0) {
        this.selectedTabIndex = (this.NaturalPersons.length > 1 ? this.NaturalPersons[1]['tabIndex'] : 0);;
      }
    }
    if (this.caisServiceService.LegalEntityDataDetails.length > 0) {
      let indexForLegalEntity = this.LegalEntities.findIndex(function (item:any, i:any) {
        return item.inCustomerRecordID == inCustomerRecordID
      });
      if (indexForLegalEntity > 0) {
        let index = (this.LegalEntities.length > 1 ?  this.LegalEntities[1]['tabIndex'] : 0);
        if (index > 0) {
          this.selectedTabIndex = index;
        }
      }
    }
    return this.selectedTabIndex;
  }

  findErrorIndexTab(inCustomerRecordID: any, index: any) {
    if (this.ExceptionInCustomerIDList.includes(inCustomerRecordID)) {
      return true;
    }
    return false;
  }

  addNewTab(tabType: string) {
    this.isClickOnTIDCorrection = false;
    if (tabType === 'Natural Person') {
      this.selectedTabIndex = 0;
    } else if (tabType === 'Legal Entity') {
      this.selectedTabIndex = this.NaturalPersons.length;
    }
  }


  handleChange(e:any) {
    this.isClickOnTIDCorrection = false;
    this.selectedTabIndex = e;
    this.caisServiceService.maskYear();
  }

  setTIDType(fieldName: any, index: number) {
    if (_.includes(['ein', 'lei'], fieldName)) {
      if ((this.caisServiceService.LegalEntityDataDetails[index]['ein'] || this.caisServiceService.LegalEntityDataDetails[index]['lei']) && !this.caisServiceService.LegalEntityDataDetails[index]['tidType']) {
        this.caisServiceService.LegalEntityDataDetails[index]['tidType'] = 'EIN';
        this.caisServiceService.LegalEntityDataDetails[index]['tidType'] = 'EIN';
        /* Generate TID Value automatically on creation of Legal Entity */
        if(index===0 || (this.caisServiceService.LegalEntityDataDetails[index]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[1] && this.caisServiceService.LegalEntityDataDetails[index]['newlyCreated']==='Yes')) {
          this.AutoGenerateTID(this.caisServiceService.LegalEntityDataDetails[index]['ein'], fieldName, index);
        }
      } else if (!this.caisServiceService.LegalEntityDataDetails[index]['ein'] && !this.caisServiceService.LegalEntityDataDetails[index]['lei'] && this.caisServiceService.LegalEntityDataDetails[index]['tidType'] === 'EIN') {
        this.caisServiceService.LegalEntityDataDetails[index]['tidType'] = null;
      }
    }
  }
   AutoGenerateTID(elemValue: any, fieldName: any, tabIndex: number) {
      if(tabIndex===0 || (this.caisServiceService.LegalEntityDataDetails[tabIndex]['tidUpdate']===this.caisServiceService.TIDUpdateStatuses[1] && this.caisServiceService.LegalEntityDataDetails[tabIndex]['newlyCreated']==='Yes')) {
        /* Auto TID Generation by EIN OR LEI Value when creating new Legal Entity */
        if(_.includes(['ein', 'tidType'], fieldName) && this.caisServiceService.LegalEntityDataDetails[tabIndex]['tidType'] === 'EIN') {
          let legalEntityEinDataFields = this.LegalEntityScreenDataDetails;
          legalEntityEinDataFields = legalEntityEinDataFields.filter((screenDataField: { field_Name: string; }) => screenDataField.field_Name === 'ein');
  
          if(legalEntityEinDataFields[0]["regexpressions"] && legalEntityEinDataFields[0]["regexpressions"].length > 0) {
            for(let j=0; j<legalEntityEinDataFields[0]["regexpressions"].length; j++) {
              if(new RegExp(legalEntityEinDataFields[0]["regexpressions"][j]).test(this.caisServiceService.LegalEntityDataDetails[tabIndex]['ein'])===true) {
                this.caisServiceService.TIDGenerator(this.caisServiceService.LegalEntityDataDetails[tabIndex]['ein']).subscribe({
                  next: (res:any) => {
                  let resultSet: any = res;
                  this.caisServiceService.LegalEntityDataDetails[tabIndex]['tidValue'] = (resultSet.tidValue ? resultSet.tidValue : "");
                }});
                break;
              }
            }
          }
        } else if (_.includes(['lei', 'tidType', 'foreignTIDType'], fieldName) && !this.caisServiceService.LegalEntityDataDetails[tabIndex]['ein'] && this.caisServiceService.LegalEntityDataDetails[tabIndex]['lei'] !== '' && this.caisServiceService.LegalEntityDataDetails[tabIndex]['tidType'] === 'FOREIGN' &&this.caisServiceService.LegalEntityDataDetails[tabIndex]['foreignTIDType'] === 'LEI') {
          this.caisServiceService.TIDGenerator(this.caisServiceService.LegalEntityDataDetails[tabIndex]['lei']).subscribe({
            next: (res:any) => {
            let resultSet: any = res;
            this.caisServiceService.LegalEntityDataDetails[tabIndex]['tidValue'] = (resultSet.tidValue ? resultSet.tidValue : "");
          }});
        }
      }
    }

  resetNaturalPerson(objectIndex: string | number) {
    /* Empty Natural Person Data Details */
    if (this.caisServiceService.NaturalPersonDataDetails[objectIndex]) {
      for (let property in this.caisServiceService.NaturalPersonDataDetails[objectIndex]) {
        this.caisServiceService.NaturalPersonDataDetails[objectIndex][property] = "";
      }
    }
    /* Empty Natural Person Address Data Details */
    if (this.caisServiceService.NaturalPersonAddressDetails.length > 0) {
      let addressColumns = this.addressColumns.map(({ db_columnname }:any) => db_columnname);
      for (let j = 1; j <= 4; j++) {
        for (let k = 0; k < addressColumns.length; k++) {
          this.caisServiceService.NaturalPersonAddressDetails[objectIndex][j - 1][addressColumns[k]] = "";
        }
      }
    }
  }

  saveNaturalPerson(objectIndex:any) {
    this.isAddLoadingResults = true;
    this.isEditLoadingResults = true;

    let isValidNaturalPerson = this.caisServiceService.validateNaturalPerson(objectIndex);

    /* Stop Page submission while found Field error */
    if (!isValidNaturalPerson) {
      this.isAddLoadingResults = false;
      this.isEditLoadingResults = false;
      return false;
    } else {
      // Remove Error Code from Row
      if (Object.keys(this.caisServiceService.NaturalPersonDataDetails[objectIndex].errorFields).length === 0) {
        delete this.caisServiceService.NaturalPersonDataDetails[objectIndex].errorFields;
      }
      this.caisServiceService.NaturalPersonDataDetails[objectIndex]['active'] = 'Y';
      this.caisServiceService.NaturalPersonDataDetails[objectIndex]['fileID'] = ((this.caisServiceService.NaturalPersonDataDetails[objectIndex]['fileID'] && this.caisServiceService.NaturalPersonDataDetails[objectIndex]['fileID'] !== null) ? this.caisServiceService.NaturalPersonDataDetails[objectIndex]['fileID'] : 0);
      let formDataObj = _.cloneDeep(this.caisServiceService.NaturalPersonDataDetails[objectIndex]);
      formDataObj =this.caisServiceService.formatData(formDataObj); // Formatting Data

      /* Add/Update Natural Person */
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          APIURL.CAIS_CLIENT_Edit
        ), {
        type: "MASTER",
        CATReporterIMID: this.userService.getActiveMPID(),
        user: this.userService.getUserName(),
        userName: this.userService.getUserFirstName(),
        reportDate: this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(this.finraExceptionRow["reportDate"]))),
        formData: formDataObj,
        createdUser: this.userService.getUserFirstName()
      })
        .subscribe({
          next: (res:any) => {
          let dataset: any = res;
          this.isAddLoadingResults = false;
          this.isEditLoadingResults = false;
          /* Add New Inserted Natural Person Tab */
          if (objectIndex === 0) {
            this.NaturalPersons.push({
              id: Object.keys(this.caisServiceService.NaturalPersonDataDetails).length,
              name: this.caisServiceService.NaturalPersonDataDetails[objectIndex]["firstName"] + ' ' + this.caisServiceService.NaturalPersonDataDetails[objectIndex]["lastName"]
            });
            this.caisServiceService.NaturalPersonDataDetails.push({ ...this.caisServiceService.NaturalPersonDataDetails[objectIndex] });
            let NaturalPersonAddresses = structuredClone(this.caisServiceService.NaturalPersonAddressDetails[objectIndex]);
            this.caisServiceService.NaturalPersonAddressDetails.push(NaturalPersonAddresses);
            this.resetNaturalPerson(objectIndex);
          }
          /* End of Adding New Inserted Natural Person Tab */
          if (dataset.status === true) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
          } else {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
          }
        }, error: (err: HttpErrorResponse) => {
          this.isAddLoadingResults = false;
          this.isEditLoadingResults = false;
        }
    });
    }
    return true;
  }



  removeNaturalPerson(objectIndex:any) {
    this.confirmationService.confirm({
      message: 'Are you sure to delete the Natural Person?',
      key: 'informationDialoge',
      acceptLabel: 'Ok',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button information-reject-button",

      accept: () => {
        this.checkAndAddtoRemovedCustomerList('Natural-Person', objectIndex); // Check And Add Removed Natural-Person in Removed Customer List
        this.NaturalPersons.splice(objectIndex, 1);
        this.caisServiceService.NaturalPersonDataDetails.splice(objectIndex, 1);
        this.caisServiceService.NaturalPersonAddressDetails.splice(objectIndex, 1);
        $(document).ready( () => {
          this.storeBirthYear.splice(objectIndex, 1);
        });

        this.selectedTabIndex = (this.selectedTabIndex > 0 ? (this.selectedTabIndex-1) : 0); // Reset and keep selected Tab to the Original Customer Tab
        this.updateFDIDInCustomerID(); // Update FDID In-CustomerID when Removing Associate Natural-Person
      },
      reject: () => {

      }
    });
  }

  removeLegalEntity(objectIndex:any) {
    this.confirmationService.confirm({
      message: 'Are you sure to delete the Legal Entity?',
      key: 'informationDialoge',
      acceptLabel: 'Ok',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button information-reject-button",

      accept: () => {
        this.checkAndAddtoRemovedCustomerList('Legal-Entity', objectIndex); // Check And Add Removed Legal-Entity in Removed Customer List
        this.LegalEntities.splice(objectIndex, 1);
        this.caisServiceService.LegalEntityDataDetails.splice(objectIndex, 1);
        this.caisServiceService.LegalEntityAddressDetails.splice(objectIndex, 1);

        this.selectedTabIndex = (this.selectedTabIndex > 0 ? (this.selectedTabIndex-1) : 0); // Reset and keep selected Tab to the Original Customer Tab
        this.updateFDIDInCustomerID(); // Update FDID In-CustomerID when Removing Associate Legal-Entity
      },
      reject: () => {

      }
    });
  }

  // Update FDID In-CustomerID when Removing Associate Customer (Natural-Person/Legal-Entity)
  updateFDIDInCustomerID() {
    // Search FDID Associated NaturalPerson OR LegalEntity
    let FDIDAssociatedNaturalPerson = this.caisServiceService.NaturalPersonDataDetails.filter((rowObj: { inCustomerRecordID: any; }) => this.caisServiceService.FDIDScreenDataDetails.inCustomerRecordID === rowObj.inCustomerRecordID);
    let FDIDAssocitedLegalEntity = this.caisServiceService.LegalEntityDataDetails.filter((rowObj: { inCustomerRecordID: any; }) => this.caisServiceService.FDIDScreenDataDetails.inCustomerRecordID === rowObj.inCustomerRecordID);

    // When don't have FDID Associated NaturalPerson OR LegalEntity then Searching and assigning Supplement Associated NaturalPerson OR LegalEntity and attach to FDID
    if(FDIDAssociatedNaturalPerson.length === 0 && FDIDAssocitedLegalEntity.length === 0) {
      let SupplementAssociatedNaturalPerson = this.caisServiceService.NaturalPersonDataDetails.find((itemObj: { inCustomerRecordID: { trim: () => { (): any; new(): any; length: number; }; }; }) => itemObj.inCustomerRecordID && itemObj.inCustomerRecordID.trim().length > 0);
      let SupplementAssociatedLegalEntity = this.caisServiceService.LegalEntityDataDetails.find((itemObj: { inCustomerRecordID: { trim: () => { (): any; new(): any; length: number; }; }; }) => itemObj.inCustomerRecordID && itemObj.inCustomerRecordID.trim().length > 0);

      // Firstly Attach Supplement associated NaturalPerson to FDID | Secondly Attach Supplement associated Legal Entity to FDID | Last Attach null if don't have Supplement associated Natural Person OR Legal Entity
      if(SupplementAssociatedNaturalPerson && SupplementAssociatedNaturalPerson.inCustomerRecordID.trim().length > 0) {
        this.caisServiceService.FDIDScreenDataDetails.inCustomerRecordID = SupplementAssociatedNaturalPerson.inCustomerRecordID;
        this.caisServiceService.removedCustomers.push(SupplementAssociatedNaturalPerson); // Add Attached Natural-Person Customer in Removed CustomerList
      } else if(SupplementAssociatedLegalEntity && SupplementAssociatedLegalEntity.inCustomerRecordID.trim().length > 0) {
        this.caisServiceService.FDIDScreenDataDetails.inCustomerRecordID = SupplementAssociatedLegalEntity.inCustomerRecordID;
        this.caisServiceService.removedCustomers.push(SupplementAssociatedLegalEntity); // Add Attached Legal-Entity Customer in Removed CustomerList
      } else if(!SupplementAssociatedNaturalPerson && !SupplementAssociatedLegalEntity && this.caisServiceService.FDIDScreenDataDetails.inCustomerRecordID && this.caisServiceService.FDIDScreenDataDetails.inCustomerRecordID.trim().length > 0) {
        this.caisServiceService.FDIDScreenDataDetails.inCustomerRecordID = null;
      }
    }
  }

  // Prepare Removed Customers (Natural-Person/Legal-Entity) Array
  checkAndAddtoRemovedCustomerList(tabName:any, objectIndex:any) {
    if(tabName==="Natural-Person") {
      let existRemovedCustomer = this.caisServiceService.removedCustomers.filter((rowObj) => rowObj.inCustomerRecordID === this.caisServiceService.NaturalPersonDataDetails[objectIndex].inCustomerRecordID);
      if(existRemovedCustomer.length===0) {
        this.caisServiceService.removedCustomers.push(this.caisServiceService.NaturalPersonDataDetails[objectIndex]);
      }
    } else if(tabName==="Legal-Entity") {
      let existRemovedCustomer = this.caisServiceService.removedCustomers.filter((rowObj) => rowObj.inCustomerRecordID === this.caisServiceService.LegalEntityDataDetails[objectIndex].inCustomerRecordID);
      if(existRemovedCustomer.length===0) {
        this.caisServiceService.removedCustomers.push(this.caisServiceService.LegalEntityDataDetails[objectIndex]);
      }
    }
  }

  resetLegalEntity(objectIndex:any) {
    /* Empty Legal Entity Data Details */
    if (this.caisServiceService.LegalEntityDataDetails[objectIndex]) {
      for (let property in this.caisServiceService.LegalEntityDataDetails[objectIndex]) {
        this.caisServiceService.LegalEntityDataDetails[objectIndex][property] = "";
      }
    }
    /* Empty Legal Entity Address Data Details */
    if (this.caisServiceService.LegalEntityAddressDetails.length > 0) {
      let addressColumns = this.addressColumns.map(({ db_columnname }:any) => db_columnname);
      for (let j = 1; j <= 4; j++) {
        for (let k = 0; k <= addressColumns.length; k++) {
          this.caisServiceService.LegalEntityAddressDetails[objectIndex][j - 1][addressColumns[k]] = "";
        }
      }
    }
  }

  saveLegalEntity(objectIndex:any) {
    this.isAddLoadingResults = true;
    this.isEditLoadingResults = true;

    let isValidLegalEntity = this.caisServiceService.validateLegalEntity(objectIndex);

    /* Stop Page submission while found Field error */
    if (!isValidLegalEntity) {
      this.isAddLoadingResults = false;
      this.isEditLoadingResults = false;
      return false;
    } else {
      // Remove Error Code from Row
      if (Object.keys(this.caisServiceService.LegalEntityDataDetails[objectIndex].errorFields).length === 0) {
        delete this.caisServiceService.LegalEntityDataDetails[objectIndex].errorFields;
      }
      this.caisServiceService.LegalEntityDataDetails[objectIndex]['active'] = 'Y';
      this.caisServiceService.LegalEntityDataDetails[objectIndex]['fileID'] = ((this.caisServiceService.LegalEntityDataDetails[objectIndex]['fileID'] && this.caisServiceService.LegalEntityDataDetails[objectIndex]['fileID'] !== null) ? this.caisServiceService.LegalEntityDataDetails[objectIndex]['fileID'] : 0);
      let formDataObj = _.cloneDeep(this.caisServiceService.LegalEntityDataDetails[objectIndex]);
      formDataObj = this.caisServiceService.formatData(formDataObj); // Formatting Data

      /* Add/Update Legal Entity */
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          APIURL.CAIS_CLIENT_Edit
        ), {
        type: "MASTER",
        CATReporterIMID: this.userService.getActiveMPID(),
        user: this.userService.getUserName(),
        userName: this.userService.getUserFirstName(),
        reportDate: this.userService.getyyyyMMddDateFormate(this.finraExceptionRow["reportDate"]),
        formData: formDataObj,
        createdUser: this.userService.getUserFirstName()
      })
        .subscribe({
          next: (res:any) => {
          let dataset: any = res;
          this.isAddLoadingResults = false;
          this.isEditLoadingResults = false;
          /* Add New Inserted Legal Entity Tab */
          if (objectIndex === 0) {
            this.LegalEntities.push({
              id: Object.keys(this.caisServiceService.LegalEntityDataDetails).length,
              name: this.caisServiceService.LegalEntityDataDetails[objectIndex]['legalName']
            });
            this.caisServiceService.LegalEntityDataDetails.push({ ...this.caisServiceService.LegalEntityDataDetails[objectIndex] });
            let LegalEntityAddresses = structuredClone(this.caisServiceService.LegalEntityAddressDetails[objectIndex]);
            this.caisServiceService.LegalEntityAddressDetails.push(LegalEntityAddresses);
            this.resetLegalEntity(objectIndex);
          }
          /* End of Adding New Inserted Legal Entity Tab */
          if (dataset.status === true) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
          } else {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
          }
        }, error: (err: HttpErrorResponse) => {
          this.isAddLoadingResults = false;
          this.isEditLoadingResults = false;
        }
    });

    }
    return true;
  }
  TIDCorrectionConfirmation(){
    this.sharedHttpClientService.get(
      this.urlService.setAPIURl(
        APIURL.CAIS_FDID_FINRA_Status+'/'+this.finraExceptionRow["firmDesignatedID"]
      ), 
    ).subscribe({
      next: (data:any) => {
        if(data.finraStatus =='ACCEPTED'){
        this.confirmationService.confirm({
          message: 'FDID/Customer is finra accepted, do you still want to do correction and not update TID?',
          key: 'confirmationDialog',
          acceptLabel: 'Yes',
          acceptIcon:'pi pi-check',
          rejectLabel: 'No',
          rejectIcon:'pi pi-times',
          acceptButtonStyleClass:"confirm-dialog-button",
          rejectButtonStyleClass:"confirm-dialog-button",
          
          accept: () => {
            this.setValuesForTIDCorrection();
          }
        });
      }
      else{
        this.setValuesForTIDCorrection();
      }
     
        }, error: (err: HttpErrorResponse) => {
          this.isAddLoadingResults = false;
          this.isEditLoadingResults = false;
    }});
  }
  setValuesForTIDCorrection() {
    this.isClickOnTIDCorrection = true;

    if (this.selectedTabIndex < this.caisServiceService.NaturalPersonDataDetails.length) {
      this.NPTIDSwitches[this.selectedTabIndex] = false;
      this.caisServiceService.NaturalPersonDataDetails[this.selectedTabIndex]['priorTidValue'] = this.caisServiceService.NaturalPersonDataDetails[this.selectedTabIndex]['tidValue'];
      this.caisServiceService.NaturalPersonDataDetails[this.selectedTabIndex]['action'] = 'CORRECTION';
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SEVERITY_INFO, detail: ' Please update TID value' });
    }

    else {
      let legalEntityIndex =0;
      if(this.caisServiceService.NaturalPersonDataDetails.length){
        legalEntityIndex  = (this.caisServiceService.NaturalPersonDataDetails.length + this.caisServiceService.LegalEntityDataDetails.length)-this.selectedTabIndex;
        legalEntityIndex = legalEntityIndex-1;
      }
      
      this.LETIDSwitches[legalEntityIndex] = false;
      this.caisServiceService.LegalEntityDataDetails[legalEntityIndex]['priorTidValue'] = this.caisServiceService.LegalEntityDataDetails[legalEntityIndex]['tidValue'];
      this.caisServiceService.LegalEntityDataDetails[legalEntityIndex]['action'] = 'CORRECTION';
      this.caisServiceService.LegalEntityDataDetails[legalEntityIndex]['tidUpdate'] = this.caisServiceService.TIDUpdateStatuses[1];
      this.caisServiceService.LegalEntityDataDetails[legalEntityIndex]['newlyCreated'] = 'Yes';
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SEVERITY_INFO, detail: ' Please update TID value' });

    }

  }

openTIDGenrator(){
  this.caisServiceService.isDisplayTIDGenerator = true;
  this.caisServiceService.isLegalEntityForeignTIDGenerator = false; 
  this.caisServiceService.isNaturalPersonForeignTIDGenerator = false;
}

  /* Apply Generated TID Value for NaturalPaerson | LegalEntity */
  applyTIDValue(userType: any, objectIndex: number) {
    if(userType==='NaturalPerson') {
      this.caisServiceService.currentNaturalPersonTIDValue.subscribe(tidValue=>{
        this.caisServiceService.NaturalPersonDataDetails[objectIndex]['tidValue'] = tidValue;
      });
    } else if(userType==='LegalEntity') {
      this.caisServiceService.currentLegalEntityTIDValue.subscribe(tidValue=>{
        this.caisServiceService.LegalEntityDataDetails[objectIndex]['tidValue'] = tidValue;
      });
    }
  }
}
